import { render, staticRenderFns } from "./_GeneralInfo.vue?vue&type=template&id=47e1c16b&"
import script from "./_GeneralInfo.vue?vue&type=script&lang=js&"
export * from "./_GeneralInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports